import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import BootstrapVue from "bootstrap-vue"
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import Axios from 'axios'
import EvaIcons from 'vue-eva-icons'

Vue.config.productionTip = false;
Vue.use(BootstrapVue)
Vue.use(EvaIcons)

// Axios Config
Axios.defaults.baseURL = 'https://api.livelines.io/v1/';

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
